import { createContext, Dispatch, SetStateAction } from 'react';
import { NOTIFICATIONS_NUMBER_OF_PLACEHOLDERS } from 'models/Notification';
import { LeadNotification } from 'models/LeadNotifications';
import { SearchableFilterValue } from 'models/Filters';
import utils from 'utils';

type LeadNotificationsContextProps = {
  fetchingNotifications: boolean;
  numberOfPlaceholders: number;
  notifications: Array<LeadNotification>;
  channel: string[];
  status: string[];
  leads: SearchableFilterValue;
  deals: SearchableFilterValue;
  setChannel: Dispatch<SetStateAction<string[]>>;
  setStatus: Dispatch<SetStateAction<string[]>>;
  setLeads: Dispatch<SetStateAction<SearchableFilterValue>>;
  setDeals: Dispatch<SetStateAction<SearchableFilterValue>>;
  resetFilters: () => void;
  onNotificationsScroll: () => void;
};

export default createContext<Partial<LeadNotificationsContextProps>>({
  fetchingNotifications: false,
  numberOfPlaceholders:
    NOTIFICATIONS_NUMBER_OF_PLACEHOLDERS.INITIAL_LOADING_COUNT,
  notifications: [],
  channel: [],
  leads: [],
  deals: [],
  setChannel: utils.noop,
  setStatus: utils.noop,
  setLeads: utils.noop,
  setDeals: utils.noop,
  resetFilters: utils.noop,
  onNotificationsScroll: utils.noop,
});
